<template>
	<div>
        <div>
			<vue-draggable-resizable
            :style="style"
            class="element-position-lowerthird "
            v-if="status==='preview' && vcamItem.is_power"
            :draggable="status ==='preview'"
            :resizable="status ==='preview'"
            :w="vcamItem.width"
            :h="vcamItem.height"
            @dragstop="onDragstop"
            @resizestop="onResizestop"
            @dragging="onDrag"
            @resizing="onResize"
            :preventActiveBehavior="true"
            :parent="false">
				<video
					:id="`panelistifrmpreview${vcamItem.order}`"
					:muted="vcamItem.is_mute"
					v-if="status==='preview' && vcamItem.is_power"
					class="nineteentwenty"
					style="pointer-events: none;"
					:style="style"
					autoplay
					scrolling="no"
					ref="videoInput">
				</video>
			</vue-draggable-resizable>

			<video
				:id="`panelistifrmpreview${vcamItem.order}`"
				:muted="vcamItem.is_mute"
				v-if="status === 'live'"
				style="pointer-events: none;"
				:style="style"
				class="nineteentwenty"
				autoplay
				scrolling="no"
				ref="videoInput">
			</video>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-return-assign */

import VueDraggableResizable from 'vue-draggable-resizable';
import {
	duplicateVar,
} from '@/lib/helper';

import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

export default {
	name: 'ElementVCam',
	props: {
		vcamItem: {
			type: Object,
		},
		status: {
			type: String,
		},
		layerIndex: {

		},
	},
	components: {
		'vue-draggable-resizable': VueDraggableResizable,
	},
	sockets: {
		connect() {
			// this.activateSocket();
		},
		vcam_live_hide(vcamId) {
			// hide here
			if (vcamId === this.localItem.id) {
				this.toggleHide();
			}
		},
		vcam_live_muteAll(data) {
			const isMute = JSON.parse(data);
			if (isMute) {
				this.mute();
			} else {
				this.unmute();
			}
		},
		vcam_live_mute(data) {
			const { id, status } = data;
			const isMuted = JSON.parse(status);
			if (id === this.localItem.id) {
				if (isMuted) {
					this.mute();
				} else {
					this.unmute();
				}
			}
		},
		vcam_live_turnOn(data) {
			// console.log(data);
			const id = data.id;
			if (id === this.localItem.id) {
				this.playVideo(this.localItem.url);
			}
		},
	},
	created() {

	},
	mounted() {
		this.playVideo(this.localItem.url);
	},
	beforeDestroy() {
		this.stopStream();
	},
	destroyed() {
		this.stopStream();
	},
	data() {
		return {
			localStream: null,
		};
	},
	methods: {
		onDragstop() {
			// console.log('asdasdasd');
		},
		onResizestop() {

		},
		onDrag() {
			// console.log('asdasdasd');
		},
		onResize() {

		},
		stopStream() {
			if (this.localStream) {
				this.localStream.getTracks().forEach((track) => {
					track.stop();
				});
			}
		},
		playVideo(deviceId) {
			navigator.mediaDevices.getUserMedia({
				video: {
					deviceId: { exact: deviceId },
				},
				audio: true,
			}).then((stream) => {
				this.localStream = stream;
				if (this.$refs.videoInput) this.$refs.videoInput.srcObject = stream;
			}).catch(() => {
				// console.log(err);
			});
		},
		toggleHide() {
			if (this.localItem.is_empty_feed && this.localItem.is_hide_label) {
				this.mute();
			} else if (!this.localItem.is_mute && (!this.localItem.is_empty_feed && !this.localItem.is_hide_label)) {
				this.unmute();
			}
		},
		mute() {
			// eslint-disable-next-line no-param-reassign
			if (this.localStream) this.localStream.getAudioTracks()[0].enabled = false;
		},
		unmute() {
			// eslint-disable-next-line no-param-reassign
			if (this.localStream) this.localStream.getAudioTracks()[0].enabled = true;
		},
	},
	computed: {
		localItem() {
			const localItem = duplicateVar(this.vcamItem);
			return localItem;
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.layerIndex;
			style.width = `${this.vcamItem && this.vcamItem.width ? this.vcamItem.width : 0}px`;
			style.height = `${this.vcamItem && this.vcamItem.height ? this.vcamItem.height : 0}px`;
			// if (content.y) style.top = `${content.y}px`;
			// if (content.x) style.left = `${content.x}px`;
			return style;
		},
	},
	watch: {
	},
};
</script>

<style lang="css" v-html="" scoped>
@import url("https://fonts.googleapis.com/css?family=Open+Sans+Condensed:300");
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  background-image: linear-gradient(rgba(200, 200, 200, 0.1) 0.1em, transparent 0.1em), linear-gradient(90deg, rgba(200, 200, 200, 0.1) 0.1em, transparent 0.1em);
  background-size: 10px 50px;

}

.twelveeighty {
  width: 1280px !important;
  height: 720px !important;
}

.nineteentwenty {
  width: 1920px !important;
  height: 1080px !important;
}

button {
  height: 50px;
  background-color: #00FF00;
}

#buttonbar {
  position: absolute;
  bottom: 20px;
  left: 100px;
  z-index: 99999 !important;
}


</style>
